export function addEllipsis($, el, opt = { truncate: 'word', watch: 'window' }) {
  if ($(el).length < 1) {
    return;
  }
  setTimeout(() => $(el).dotdotdot(opt), 50);
}
